import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
    resources: {
        en: {
            translation: {
                unowned: "unowned",
                home: "Home",
                earn: "Earn",
                frens: "Frens",

                loading: "Loading",
                error: "Error",
                success: "Success",

                price: "Price",
                market_cap: "Market Cap",
                volume24: "24h Volume",
                date: "Date",
                dates: "Dates",
                hour: "hour",
                day: "day",
                week: "week",
                month: "month",
                year: "year",

                lang: "Lang",
                type: "Type",
                coinmarketcap: "Coinmarketcap",
                ton: "Ton",
                period: "Period",
                pages: "Pages",
                app_info: "App info",

                every_watch: "for every watch",
                daily_limit: "Daily limit",
                total_views: "Total views",
                check: "Check",
                go: "Go",
                work_only_in_telegram_version: "Work only in telegram version",
                adsgram_script_not_loaded: "Adsgram script not loaded",
                subscribe_error: "Subscribe error",
                you_watch_max_count_today: "You watch max count today",
                invite_form_frens_tip: "When distributing AirDrop you'll get 15% from frens balances",
                airdrop_description: "Airdrop description",
                you_earn: "You earn",

                you_invite_from: "You Invite from",
                invite_a_fren: "Invite a fren",
                copied: "Copied",
                search: "Search",
                cryptocurrency: "Cryptocurrency",

                all: 'All',
                one_time: 'One time',
                multiple: 'Multiple',
                activities: 'Activities',
                activities_new_tip: "For add your activity to list, contact with",
                activity_requirements: "Requirements",
                activity_requirements_twitter: "Twitter",
                activity_requirements_wallet_mm: "Metamask wallet",
                activity_requirements_galxe: "Account Galxe",
                activity_instruction: "Instruction",
                activity_today_is_completed: "Today activity is completed",
                completed: "Completed",
                steps: 'Steps'
            }
        },
        ru: {
            translation: {
                unowned: "unowned",
                home: "Главная",
                earn: "Доход",
                frens: "Друзья",

                loading: "Загрузка",
                error: "Ошибка",
                success: "Успех",

                price: "Цена",
                market_cap: "Market Cap",
                volume24: "24h Volume",
                date: "Дата",
                dates: "Даты",
                hour: "час",
                day: "день",
                week: "неделя",
                month: "месяц",
                year: "год",

                lang: "Язык",
                type: "Тип",
                coinmarketcap: "Coinmarketcap",
                ton: "Ton",
                period: "Период",
                pages: "Страница",
                app_info: "App info",

                every_watch: "за каждый просмотр",
                daily_limit: "Ежедневный лимит",
                total_views: "Всего просмотров",
                check: "Проверить",
                go: "Старт",
                work_only_in_telegram_version: "Работает только в телеграмм",
                adsgram_script_not_loaded: "Adsgram скрипт не загружен",
                subscribe_error: "Ошибка подписки",
                you_watch_max_count_today: "На сегодня достигнут лимит просмотров",
                invite_form_frens_tip: "При распределении AirDrop вы получите 15% от балансов ваших друзей",
                airdrop_description: "Airdrop описание",
                you_earn: "Ваш баланс",

                you_invite_from: "Вас пригласил",
                invite_a_fren: "Пригласить друга",
                copied: "Скопировано",
                search: "Поиск",
                cryptocurrency: "Криптовалюта",

                all: 'Все',
                one_time: 'Один раз',
                multiple: 'Multiple',
                activities: 'Активности',
                activities_new_tip: "Чтобы добавить в список свою активность, напишите в",
                activity_requirements: "Требуется",
                activity_requirements_twitter: "Твиттер",
                activity_requirements_wallet_mm: "Колешек Metamask",
                activity_requirements_galxe: "Аккаунт на Galxe",
                activity_instruction: "Инструкция",
                activity_today_is_completed: "Сегодня активность выполнена",
                completed: "Выполнено",
                steps: 'Шаги'
            }
        },
    },
    lng: "en",
    fallbackLng: "en"
});

export default i18n;
